/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import { closePanel, openPanel } from "../../Redux/Panels/RightPanel/actions";
import { updateSearchParameters } from "../../Redux/SearchEngine/actions";


const MapSearchBox = (props) => {

	return (
		<div
			id={"pac-input-container"}
			className="mapboxgl-ctrl-geocoder mapboxgl-ctrl demo-card"
			style={props?.order ? {} : props?.showSearch ? {} : { display: "none" }}
		>
			<div
				className={`search-list pickup-point ${props?.showOpen ? "" : "full"}`}
			>
				<i className="text-center mapboxgl-ctrl-geocoder--icon mapboxgl-ctrl-geocoder--icon-search fas fa-dot-circle text-danger"></i>

				<input
					id={"pac-input-pickup"}
					type="text"
					className="mapboxgl-ctrl-geocoder--input"
					placeholder={"Enter your address"}
					aria-label="Search"
					style={{ border: props?.configure?"none":"" }}
				/>
				{props?.searchParameters?.map && (
					<input 
						type="range" 
						defaultValue={props?.searchParameters?.range} 
						style={{ width: "100%" }} 
						min={5}
						max={100}
						onChange={e => {
							props.updateSearchParameters({ range: e.target.value })
						}}
						/>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		open: state.rightPanel.open,
		searchParameters: state.searchParameters
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		openPanel: (e) => dispatch(openPanel(e)),
		closePanel: (e) => dispatch(closePanel(e)),
		updateSearchParameters: (e) => dispatch(updateSearchParameters(e))
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(MapSearchBox);
